import { api } from '@src/lib/api-client';
import { QueryConfig } from '@src/lib/react-query';
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export enum BetaFeaturesEnum {
  'AIR_MAX' = 'air_max',
  'AIR_MAX_BETA' = 'air_max_beta',
  'COMMON_APPLICATION_V2' = 'common_application_v2',
}

export type GetBetaFeaturesResponse = [BetaFeaturesEnum, boolean];

export async function getBetaFeatures(): Promise<GetBetaFeaturesResponse[]> {
  return await api
    .get(`/api/v3/user/beta-features`)
    .then((res: AxiosResponse<GetBetaFeaturesResponse[]>) => res.data);
}

export const getBetaFeaturesQueryOptions = queryOptions({
  queryKey: ['betaFeatures'],
  queryFn: getBetaFeatures,
});

type UseGetBetaFeaturesOptions = {
  queryConfig?: QueryConfig<typeof getBetaFeaturesQueryOptions>;
};

export const useGetBetaFeatures = ({
  queryConfig,
}: UseGetBetaFeaturesOptions = {}) => {
  return useSuspenseQuery({ ...getBetaFeaturesQueryOptions, ...queryConfig });
};
